import { useState } from 'react';
import { bridge, useAsyncEffect } from '../../utils';
import { useIsForegroundNow } from '../useIsForegroundNow';

type UseOutfitBookMarkMapProps = {
  /** - api응답으로 생성한 likeMap */
  initialMap?: Record<string, boolean>;
};
export const useOutfitBookmarkMap = (params: UseOutfitBookMarkMapProps) => {
  const [bookmarkMap, setBookmarkMap] = useState<Record<string, boolean>>(
    params.initialMap ?? {},
  );

  const isForeground = useIsForegroundNow();

  useAsyncEffect(async () => {
    if (isForeground) {
      const localGoodsLike = await bridge.getLocalOutfitBookmark();

      setBookmarkMap(prev => ({
        ...prev,
        ...localGoodsLike,
      }));
    }
  }, [isForeground]);

  return { bookmarkMap, setBookmarkMap };
};
